<bn-loading-overlay></bn-loading-overlay>

<div class="container" *ngIf="recuperacaoCredito; else carregando">

    <div class="row">
        <div class="col">
            <h3>Detalhes da Recuperação de Crédito <small class="text-muted">(#ID: {{recuperacaoCredito?.id}})</small></h3>
        </div>
        <div class="col-auto">
            <button class="btn btn-primary" type="button" (click)="voltarParaLista ()">Voltar</button>
            <button *ngIf="podeReprovar || podeCancelar" [disabled] = "recuperacaoCredito.estado.id != 1"
                class="btn btn-light" type="button" (click)="reprovar()">{{podeReprovar ? 'Reprovar' : 'Cancelar'}}</button>
        </div>
    </div>

    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="col nav-tabs">

        <li title="Recuperação" [ngbNavItem]>
        <a ngbNavLink>Recuperação</a>
        <ng-template ngbNavContent>
        <div class="row" >
            <div [ngClass]="'bn-form-group ' + (recuperacaoCredito.sistemaRepasse ? 'col-md-4' : 'col-md-6')">
                <label><b>Agente financeiro</b></label>
                <input type="text" class="form-control" name="nomeAgenteFinanceiro" value="{{nomeAgente(recuperacaoCredito.cnpjAgenteFinanceiro)}}" disabled />
            </div>
            <div [ngClass]="'bn-form-group ' + (recuperacaoCredito.sistemaRepasse ? 'col-md-3' : 'col-md-6')" *ngIf="recuperacaoCredito.idOperacaoExterno">
                <label><b>Id. operação agente</b></label>
                <input type="text" class="form-control" name="idOperacaoAgente" value="{{recuperacaoCredito.idOperacaoExterno}}"  disabled />
            </div>
            <div class="bn-form-group col-md-2" *ngIf="recuperacaoCredito.sistemaRepasse">
                <label><b>Sistema</b></label>
                <input type="text" class="form-control" value="{{recuperacaoCredito.sistemaRepasse}}" disabled />
            </div>
            <div class="bn-form-group col-md-3" *ngIf="recuperacaoCredito.contratoRepasse">
                <label><b>Contrato</b></label>
                <div class="input-group">
                    <input type="text" class="form-control" [value]="recuperacaoCredito.contratoRepasse" disabled />
                    <span class="input-group-text" *ngIf="permissaoLinkN03 && recuperacaoCredito.contratoRepasse">
                        <a href="/n03_spa/#!/amb-ope/subcredito/documento-nivel/numero/{{recuperacaoCredito.contratoRepasse}}">
                            <i class="fa fa-external-link-alt" ngbTooltip="Acessar Operação"></i>
                        </a>
                    </span>
                </div>
            </div>
        </div>
        <div class="row" >
            <div class="bn-form-group col-md-4">
                <label><b>Estado</b></label>
                <input type="text" class="form-control" name="nomeEstado" value="{{recuperacaoCredito.estado.nomeEstado}}" disabled />
            </div>
            <div class="bn-form-group col-md-6">
                <label><b>Motivo</b></label>
                <input type="text" class="form-control" name="motivoEstado" value="{{recuperacaoCredito.estado.motivoEstado}}" disabled />
            </div>
           
            <div class="bn-form-group col-md-2">
                <label><b>Id. cobrança</b></label>
                <div class="input-group">
                    <input type="text" class="form-control" name="idCobranca" value="{{recuperacaoCredito.detalhe.identificadorCobranca}}" disabled />
                        <span class="input-group-text" *ngIf="recuperacaoCredito.detalhe.identificadorCobranca"><a 
                            href="#/cobrancas/{{recuperacaoCredito.detalhe.identificadorCobranca}}"><i
                                class="fa fa-external-link-alt" ngbTooltip="Ver detalhes da cobrança"></i></a></span>
                 </div>
            </div>
        </div>
        <div class="row" >
            <div class="bn-form-group col-md-2">
                <label><b>Data de envio</b></label>
                <bn-datepicker name="dataRecuperacao" [(ngModel)]="recuperacaoCredito.dataEnvio" disabled></bn-datepicker>
            </div>
            <div class="bn-form-group col-md-2">
                <label><b>Data da recuperação</b></label>
                <bn-datepicker name="dataRecuperacao" [(ngModel)]="recuperacaoCredito.dataRecuperacao" disabled></bn-datepicker>
            </div>
            <div class="bn-form-group col-md-2">
                <label><b>Saldo Liquidado</b></label>
                <input type="checkbox" class="form-check checkbox-gigante" [checked]="recuperacaoCredito.saldoLiquidado == 'true'" disabled />
            </div>
            <div class="bn-form-group col-md-2">
                <label><b>Reversão de honra</b></label>
                <input type="checkbox" class="form-check checkbox-gigante" [checked]="recuperacaoCredito.reversaoHonra == 'true'" disabled />
            </div>
            <div class="bn-form-group col-md-2">
                <label><b>Multa</b></label>
                <input type="checkbox" class="form-check checkbox-gigante" [checked]="recuperacaoCredito.temMulta == 'true'" disabled />
            </div>
            <div class="bn-form-group col-md-2">
                <label><b>Estorno Manual</b></label>
                <select class="form-select" id="estornoManual" name="estornoManual" [(ngModel)]="estornoManual" 
                    (change)="abrirModalConfirmarAlteracaoEstorno()"
                    [disabled]="!(podeLancarEstorno && recuperacaoCredito?.estado.id == 4)">
                    <option [ngValue]=undefined></option>
                    <option [value]="item.valor" *ngFor="let item of tiposEstorno">
                        {{item.nome}}
                    </option>
                </select>
            </div>
        </div>
        <div class="row" >
            <div class="bn-form-group col-md-3">
                <label><b>Valor da recuperação</b></label>
                <input type="text" class="form-control moeda" name="valorRecuperacao" value="{{recuperacaoCredito.valorRecuperacao | bnMask:'MOEDA'}}" disabled />
            </div>

            <div class="bn-form-group col-md-3">
                <label><b>Valor devido ao {{nomeModalidade}}</b></label>
                <input type="text" class="form-control moeda" name="valorRecuperacao" value="{{recuperacaoCredito.valorDevidoAoFgiPeac | bnMask:'MOEDA'}}" disabled />
            </div>

            <div class="bn-form-group col-md-3">
                <label><b>Val. honrado a recuperar antes</b></label>
                <input type="text" class="form-control moeda" name="valorRecuperacao" value="{{recuperacaoCredito.valorHonradoARecuperarAntes | bnMask:'MOEDA'}}" disabled />
            </div>

            <div class="bn-form-group col-md-3">
                <label><b>Val. honrado a recuperar após</b></label>
                <input type="text" class="form-control moeda" name="valorRecuperacao" value="{{recuperacaoCredito.valorHonradoARecuperarDepois | bnMask:'MOEDA'}}" disabled />
            </div>           
            
        </div>
        </ng-template></li>

        <li title="Histórico" *ngIf="recuperacaoCredito.detalhe.historicoEstados?.length > 0" [ngbNavItem]>
        <a ngbNavLink>Histórico</a>
        <ng-template ngbNavContent>
        <div class="table-responsive">
        <table class="table table-hover">
            <thead>
            <tr>
                <th scope="col">Data</th>
                <th scope="col">Estado</th>
                <th scope="col">Motivo</th>
                <th scope="col">Responsável</th>
            <tr>
            </thead>
            <tbody>
            <tr *ngFor="let hist of recuperacaoCredito.detalhe.historicoEstados">
                <td>{{ hist.dataUltimaAtualizacao | date:'dd/MM/yyyy H:mm'}}</td>
                <td>{{ hist.estado.nomeEstado }}</td>
                <td>{{ hist.estado.motivoEstado}}</td>
                <td>{{ hist.nomeUsuarioResponsavel}}</td>
            </tr>
            </tbody>
        </table>
        </div>
        </ng-template></li>

    </ul>
    <div [ngbNavOutlet]="nav"></div>
</div>

<ng-template #reprovacao>
    <label for="motivoReprovacao"><b>Motivo para {{podeReprovar ? 'reprovação' : 'exclusão'}}</b></label>
    <input type="text" class="form-control" id="motivoReprovacao" name="motivoReprovacao" [(ngModel)]="motivoReprovacao" required />
</ng-template>
<ng-template #reprovacaoBotoes >
    <button class="btn btn-default" (click)="cancelaReprovacao()">Cancelar</button>
    <button class="btn btn-primary" (click)="confirmaReprovacao()">Confirmar</button>
</ng-template>

<ng-template #confirmEstorno>
  <span> Confirma a alteração no campo Estorno Manual? </span>
  <br />
</ng-template>
<ng-template #confirmEstornoBotoes>
  <button class="btn btn-md btn-success" (click)="atualizaEstornoManual()">Sim</button>
  <button class="btn btn-md btn-danger" (click)="cancelarEstorno()">Não</button>
</ng-template>

<div class="container row" *ngIf="ocorrencias?.length > 0">
	<div class="table-responsive">
		<table class="table-striped table-bordered">
			<thead>
				<tr>
					<th class="text-center">Erro(s) encontrado(s)</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let ocorrencia of ocorrencias">
					<td>{{ ocorrencia.mensagem }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>

<ng-template #carregando>
  <div class="loading-pesquisa">
    <i class="bn-loading"></i>
  </div>
</ng-template>
